<template>
  <CCol col="8" :md="{offset: '2'}">
    <CCard>
      <CCardHeader color="dark" class="text-white">
        Aula
      </CCardHeader>
      <CCardBody>

        <CRow>
          <CCol col="8">
            <CInput
              label="Nome da Aula"
              v-model.trim="form.name"
              :isValid="isValid('name')"
              :invalidFeedback="errorMessage('name')"
            />
          </CCol>
          <CCol col="2" :md="{offset: '1'}">
            <label>Publicado</label>
            <br/>
            <CSwitch
              color="primary"
              :checked.sync="form.published"
              variant="opposite" 
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol col="12">
            <label>Conteúdo</label>
            <ckeditor 
              :editor="editor" 
              v-model="form.content" 
              :config="editorConfig"
              tag-name="textarea">
            </ckeditor>
          </CCol>
        </CRow>
        
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol col="2">
            <CButton color="danger" @click="cancel">Cancelar</CButton>
          </CCol>
          <CCol col="2" :md="{offset: '8'}" style="text-align:right">
            <CButton color="primary" @click="save">Salvar</CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
  </CCol>
</template>

<script>
import vSelect from 'vue-select'
import { Cropper } from 'vue-advanced-cropper'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment'
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor'
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily'
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize'
import MediaEmbedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import TablePlugin from '@ckeditor/ckeditor5-table/src/table'

import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'


export default {
    name: 'Formation',
    components: {
      ckeditor: CKEditor.component,
      Cropper,
      vSelect
    },

    data () {
      return {
        editor: ClassicEditor,
        editorConfig: {
          plugins: [
            HeadingPlugin,
            EssentialsPlugin,
            BoldPlugin,
            ItalicPlugin,
            LinkPlugin,
            ParagraphPlugin,
            AlignmentPlugin,
            MediaEmbedPlugin,
            FontColorPlugin,
            FontFamilyPlugin,
            FontSizePlugin,
            TablePlugin
          ],
          toolbar: {
            items: [
              'fontFamily',
              'fontSize',
              'fontColor',
              'heading',
              '|',
              'bold',
              'italic',
              '|',
              'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify',
              '|',
              'mediaEmbed',
              'link',
              'undo',
              'redo',
              '|',
              'insertTable'
            ]
          },
          mediaEmbed: {
            previewsInData: true,
          }
        },
        form: {
            name: '',
            content: '',
            published: true,
        },
        formErrors: {},
        errorMessages: {
          name: {
            required : 'Nome é obrigatório',
            minLength : 'O nome precisa ter ao menos 4 caracteres',

          }
        }
      }
    },

    validations() {
      let validate = {
        form: {
          name: {
            required,
            minLength: minLength(4)
          },
          content: {
            required,
          },
        }
      }
      return validate
    },

    created() {
      this.$loading(true)
    },

    mounted() {
      if (this.$route.params.id > 0)
      {
        this.$http.get('/api/lessons/' + this.$route.params.formation + '/' + this.$route.params.id)
        .then(res => {
          if (res.status === 200)
          {
            this.form = res.data.lesson

            this.$v.$touch()
            this.$loading(false)
          }
        })
        .catch(error => {
            
        });
      } else {
        this.$loading(false)
        this.$v.$touch()
      }
    },

    methods: {

      save () {
        this.formErrors = {}
        this.$v.$touch()
        if (!this.$v.$invalid) 
        {
          if (this.$route.params.id == 0)
          {
            this.$http.post('/api/lessons/' + this.$route.params.formation, this.form)
            .then(res => {
              if (res.status === 200)
              {
                if (res.data.code === 0)
                {
                  this.$swal({
                    icon: 'success',
                    title: 'Aula adicionada com sucesso!',
                  })
                  this.$router.push({'path': '/formations/lessons/'+this.$route.params.formation})
                }
              } else {
                this.formErrors = res.data.errors
              }
            })
            .catch(error => {
                
            });
          } else {
            this.$http.put('/api/lessons/' + this.$route.params.formation + '/' + this.$route.params.id, this.form)
            .then(res => {
              if (res.status === 200)
              {
                if (res.data.code === 0)
                {
                  this.$swal({
                    icon: 'success',
                    title: 'Aula editada com sucesso!',
                  })
                  this.$router.push({'path': '/formations/lessons/'+this.$route.params.formation})
                }
              } else {
                this.formErrors = res.data.errors
              }
            })
            .catch(error => {
                
            });
          }

        }
      },

      cancel () {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Deseja realmente cancelar?',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({'path': '/formations/lessons/'+this.$route.params.formation})
          }
        })
      },

      isValid: function(k) {
        let ret = (this.$v.form[k].$error !== undefined)
                ? !this.$v.form[k].$error
                : true
        if (this.formErrors !== undefined) 
        {
          if (this.formErrors[k] !== undefined)
          {
            ret = false
          }
        }
          
        return ret
      },
      errorMessage: function(k) {
          if (this.formErrors[k] === undefined)
          {
              let v = this.$v.form[k]
              let obj = Object.keys(v)

              for(let i = 0; i < (obj.length - 8); i++)
              {
              if (!v[obj[i]])
                  if (this.errorMessages[k] !== undefined)
                  return (this.errorMessages[k][obj[i]] !== undefined)  
                      ? this.errorMessages[k][obj[i]] 
                      : 'Verifique o valor informado'
              }
          } else {
              return this.formErrors[k][0]
          }
      },
    }

}
</script>
<style scoped>
.course-card > header {
  text-align: center;
  font-weight: 600;
}
.course-card .card-body {
  min-height: 20vh;

  padding: 0;
}
.course-card > footer {
  padding: 0;
}
</style>
<style>
.ck-editor__editable {
  min-height: 500px;
}
.upload-imagem-cropper {
  background-color: rgb(231, 231, 231);
	border: dashed 1px rgb(121, 120, 120);
	height: 252px;
	width: 100%;
}

.button-wrapper, .button-wrapper-remove {
	display: flex;
	justify-content: center;
	margin-top: 17px;
}

.button-wrapper > .button {
	color: white;
	font-size: 16px;
	padding: 10px 20px;
	background: #3fb37f;
	cursor: pointer;
	transition: background 0.5s;
}

.button-wrapper-remove > .button {
	color: white;
	font-size: 16px;
	padding: 10px 20px;
	background: #e55353;
	cursor: pointer;
	transition: background 0.5s;
}


.button-wrapper > .button:hover {
	background: #38d890;
}

.button-wrapper-remove > .button:hover {
	background: #df0f0f;
}

.button input {
	display: none;
}
</style>
